import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { api, apiErr } from "@/lib/api";
import { money } from "@/lib/daytime";

export function FamilyPicker({ value, onPick }) {
  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);
  useEffect(() => { const t = setTimeout(() => api.get(`/daytime/admin/families?q=${encodeURIComponent(q)}`).then((r) => setRows(r.data)).catch(() => {}), 250); return () => clearTimeout(t); }, [q]);
  return (
    <div>
      <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search parent name or email" className="rounded-xl" data-testid="dt-family-search" />
      <div className="max-h-40 overflow-y-auto mt-1 space-y-1">
        {rows.map((p) => (
          <button key={p.id} onClick={() => onPick(p)} data-testid={`dt-family-${p.id}`} className={`w-full text-left text-sm rounded-lg px-3 py-1.5 border ${value?.id === p.id ? "border-navy bg-navy/5" : "border-slate-100"}`}>
            <b>{p.name}</b> <span className="text-slate-400">{p.email}</span><span className="block text-[11px] text-slate-500">{p.explorers.map((e) => e.name).join(", ") || "no explorers"}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export function DaytimeManualBook({ date, onDone }) {
  const [fam, setFam] = useState(null);
  const [kids, setKids] = useState([]);
  const [override, setOverride] = useState(false);
  const [comp, setComp] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    if (!fam || !kids.length) return toast.error("Pick a family and at least one Explorer");
    setBusy(true);
    try {
      const { data } = await api.post("/daytime/admin/book", { parent_id: fam.id, child_ids: kids, dates: [date], override, comp });
      toast.success(`Booked ${data.bookings.length} · ${data.order ? `${money(data.order.amount)} due (ref ${data.order.reference})` : "no charge"}`);
      setKids([]); onDone();
    } catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };
  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-4 h-fit space-y-3" data-testid="dt-manual-book">
      <p className="font-display font-extrabold text-navy">Add a booking manually · {date}</p>
      <FamilyPicker value={fam} onPick={(p) => { setFam(p); setKids([]); }} />
      {fam && <div className="flex flex-wrap gap-2">{fam.explorers.map((e) => (
        <button key={e.id} onClick={() => setKids(kids.includes(e.id) ? kids.filter((k) => k !== e.id) : [...kids, e.id])} data-testid={`dt-manual-child-${e.id}`}
          className={`px-3 py-1.5 rounded-full border text-sm ${kids.includes(e.id) ? "bg-navy text-white border-navy" : "border-slate-200"}`}>{e.name}</button>))}</div>}
      <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={override} onChange={(e) => setOverride(e.target.checked)} data-testid="dt-manual-override" /> Override capacity / closed day</label>
      <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={comp} onChange={(e) => setComp(e.target.checked)} data-testid="dt-manual-comp" /> Complimentary (no charge, no pass used)</label>
      <p className="text-[11px] text-slate-400">Active passes/memberships are used automatically; otherwise a Day Pass charge is created.</p>
      <Button onClick={submit} disabled={busy} className="w-full rounded-full bg-turquoise text-navy font-bold" data-testid="dt-manual-submit">Book</Button>
    </div>
  );
}
